import React from "react";
import {Link} from "react-router-dom";
import logo from "../assets/logo100.png";

const GithubIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0 1 12 6.844a9.59 9.59 0 0 1 2.504.337c1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.02 10.02 0 0 0 22 12.017C22 6.484 17.522 2 12 2z"/>
  </svg>
);

const TMDBIcon = () => (
  <svg width="16" height="16" viewBox="0 0 185.27 133.4" fill="none">
    <defs>
      <linearGradient id="tmdb-grad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#90cea1"/>
        <stop offset="100%" stopColor="#01b4e4"/>
      </linearGradient>
    </defs>
    <rect width="185.27" height="133.4" rx="10" fill="url(#tmdb-grad)"/>
    <text x="12" y="100" fontSize="90" fontWeight="900" fill="white" fontFamily="Arial Black, sans-serif">T</text>
  </svg>
);

const LINKS = {
  browse: [
    {label: "Popular Movies", to: "/movflix/discover/movie?category=popular"},
    {label: "Top Rated Movies", to: "/movflix/discover/movie?category=best"},
    {label: "Upcoming Movies", to: "/movflix/discover/movie?category=upcoming"},
    {label: "Popular Shows", to: "/movflix/discover/tv?category=popular"},
    {label: "On the Air", to: "/movflix/discover/tv?category=on_the_air"},
  ],
  discover: [
    {label: "Browse All", to: "/movflix/catalogue"},
    {label: "Swipe & Discover", to: "/movflix/swipe"},
    {label: "Search", to: "/movflix/search"},
  ],
  account: [
    {label: "My Profile", to: "/movflix/profile"},
    {label: "Watched", to: "/movflix/lists?type=watched"},
    {label: "Favorites", to: "/movflix/lists?type=favorites"},
    {label: "Watchlist", to: "/movflix/lists?type=watchlist"},
    {label: "Settings", to: "/movflix/settings"},
  ],
};

export const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-border bg-surface mt-10 max-[768px]:mb-[60px]">
      <div className="w-full max-w-page mx-auto px-20 py-12 max-[1280px]:px-12 max-[1024px]:px-8 max-[768px]:px-4 max-[768px]:py-8">

        {/* Top — logo + columns */}
        <div className="grid gap-10 grid-cols-[220px_1fr] max-[900px]:grid-cols-1">

          {/* Brand */}
          <div className="flex flex-col gap-4">
            <Link to="/movflix/" className="flex items-center gap-2.5 no-underline w-fit">
              <img src={logo} className="h-9 w-auto" alt="Movflix" />
              <span className="text-[1.1rem] font-bold text-t1 tracking-[-0.3px]">Movflix</span>
            </Link>
            <p className="text-[13px] text-t3 leading-relaxed max-w-[200px]">
              Your personal movie companion. Browse, track, and discover films and shows.
            </p>
            <a
              href="https://github.com/definitelyDefi/movflix"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-[13px] text-t3 hover:text-t1 transition-colors no-underline w-fit"
            >
              <GithubIcon />
              definitelyDefi/movflix
            </a>
          </div>

          {/* Link columns */}
          <div className="grid grid-cols-3 gap-8 max-[640px]:grid-cols-2 max-[400px]:grid-cols-1">

            <div>
              <h3 className="text-[11px] font-bold text-t3 uppercase tracking-[0.6px] mb-3">Browse</h3>
              <ul className="flex flex-col gap-2">
                {LINKS.browse.map(({label, to}) => (
                  <li key={to}>
                    <Link to={to} className="text-[13px] text-t2 hover:text-accent transition-colors no-underline">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-[11px] font-bold text-t3 uppercase tracking-[0.6px] mb-3">Discover</h3>
              <ul className="flex flex-col gap-2">
                {LINKS.discover.map(({label, to}) => (
                  <li key={to}>
                    <Link to={to} className="text-[13px] text-t2 hover:text-accent transition-colors no-underline">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="text-[11px] font-bold text-t3 uppercase tracking-[0.6px] mb-3">Account</h3>
              <ul className="flex flex-col gap-2">
                {LINKS.account.map(({label, to}) => (
                  <li key={to}>
                    <Link to={to} className="text-[13px] text-t2 hover:text-accent transition-colors no-underline">
                      {label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-border my-8" />

        {/* Bottom bar */}
        <div className="flex items-center justify-between gap-4 flex-wrap max-[640px]:flex-col max-[640px]:items-start">
          <p className="text-[12px] text-t3">
            © {year} Movflix · Built by{" "}
            <a
              href="https://github.com/definitelyDefi"
              target="_blank"
              rel="noopener noreferrer"
              className="text-t2 hover:text-accent transition-colors no-underline"
            >
              definitelyDefi
            </a>
          </p>

          <div className="flex items-center gap-1.5 text-[12px] text-t3">
            <span>Powered by</span>
            <a
              href="https://www.themoviedb.org"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1.5 no-underline text-t2 hover:text-accent transition-colors"
            >
              <TMDBIcon />
              TMDB
            </a>
            <span>·</span>
            <a
              href="https://clerk.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-t2 hover:text-accent transition-colors no-underline"
            >
              Clerk
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
